import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';

import { cn } from '@/hen-ui/utils';
import { CheckIcon } from 'lucide-react';
export interface CheckboxProps
  extends React.ComponentProps<typeof CheckboxPrimitive.Root> {
  isButton?: boolean;
}

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(({ className, isButton, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    data-slot='checkbox'
    className={cn(
      // Base styles
      'flex size-4 items-center justify-center rounded-[4px] border transition-colors relative shrink-0 outline-none',
      // Default (neutral)
      'border-neutral-200',
      // Checked state
      'data-[state=checked]:bg-primary-700 data-[state=checked]:text-white data-[state=checked]:border-primary-700',
      // Focus state - to focus on the checkbox and not the button when it isn't a button
      !isButton &&
        'focus:border-neutral-500 focus:ring focus:ring-neutral-100 hover:border-neutral-500 hover:ring hover:ring-neutral-100',
      // Invalid state
      'aria-[invalid=true]:border-error-500',
      // Checked + Invalid
      'aria-[invalid=true]:data-[state=checked]:bg-error-500 aria-[invalid=true]:data-[state=checked]:border-error-500',
      // Invalid + Focus - to focus on the checkbox and not the button when it isn't a button
      !isButton &&
        'aria-[invalid=true]:focus:ring-error-300 aria-[invalid=true]:hover:ring aria-[invalid=true]:hover:ring-error-300',
      // Disabled state
      'disabled:cursor-not-allowed disabled:opacity-50 disabled:ring-0 disabled:hover:border-neutral-200',
      // Clickable area
      'after:absolute after:-inset-x-3 after:-inset-y-2',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      data-slot='checkbox-indicator'
      className='[&>svg]:size-3.5 grid place-content-center text-current transition-none'
    >
      <CheckIcon />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));

Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
